"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CONFIG_TYPES;
(function(CONFIG_TYPES) {
  CONFIG_TYPES["AWS_KEY"] = "aws-key";
  CONFIG_TYPES["AWS_ROLE"] = "aws-role";
  CONFIG_TYPES["AWS_ORG"] = "aws-org";
  CONFIG_TYPES["AWS_ORG_MEMBER"] = "aws-org-member";
  CONFIG_TYPES["CONSTANT"] = "constant";
  CONFIG_TYPES["SSH"] = "ssh";
  CONFIG_TYPES["SLACK"] = "slack";
  CONFIG_TYPES["AWS_PROXY"] = "aws-proxy";
  CONFIG_TYPES["SSH_PROXY"] = "ssh-proxy";
  CONFIG_TYPES["ENDPOINT"] = "endpoint";
  CONFIG_TYPES["CONTROL"] = "control";
  CONFIG_TYPES["GROUP"] = "config-group";
  CONFIG_TYPES["AZURE"] = "azure";
  CONFIG_TYPES["WOLKEN_CMDB"] = "wolken-cmdb";
  CONFIG_TYPES["VMWARE"] = "vmware";
  CONFIG_TYPES["Events"] = "event";
  CONFIG_TYPES["Kubernetes"] = "kubernetes";
  CONFIG_TYPES["TerraformCloud"] = "tfcloud";
  CONFIG_TYPES["RESTRICTIONS"] = "restrictions";
  CONFIG_TYPES["GCP"] = "gcp";
})((CONFIG_TYPES = exports.CONFIG_TYPES || (exports.CONFIG_TYPES = {})));
//# sourceMappingURL=configTypes.js.map
